import { render, staticRenderFns } from "./FormItemSelectBranch.vue?vue&type=template&id=0702e21b&"
import script from "./FormItemSelectBranch.vue?vue&type=script&lang=js&"
export * from "./FormItemSelectBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports